import React from 'react';
import { useNavigate } from 'react-router-dom';

const Product = ({product}) => {
    const{_id,name,price,description,picture,min_order,total_quantity}=product;

    const navigate=useNavigate();
    const navigateToPurchase=id=>{
        navigate(`/products/${id}`)
    }

    return (
      
        <div
        data-aos='flip-up'
        data-aos-duration='1000'
        data-aos-delay='200'
        className='card lg:w-96 sm:w-full shadow-2xl  mt-5 border-2 border-secondary mx-10 mb-5 hover:bg-primary hover:text-white hover:btn-success text-left   '>
       <div>
       <figure><img style={{height:'200px'}} className='pb-5 rounded-md w-full transition transform duration-500 hover:scale-125' src={picture} alt="Album"/></figure>
        <div class="card-body ">
          <h2 class="card-title">{name}</h2>
          <p className='text-2xl'>Price: ${price}</p>
          <p>Description: {description}</p>
          <p>Minimum order Quantity: {min_order}</p>
          <p>Quantities left: {total_quantity}</p>

          <div class="card-actions">
      <button onClick={()=>navigateToPurchase(_id)} class="btn btn-primary  hover:btn-info">Buy Now</button>
    </div>
         
        </div>
       </div>
      </div>
    );
};

export default Product;